import Request from "@/apis/request";

interface ApisVO {
  http: Request | undefined;
}

class Apis implements ApisVO {
  http: Request | undefined;

  constructor() {
    if (!this.http) {
      this.http = new Request();
    }
  }

  /** 登录 */
  postLogin = (params?: any) => {
    return this.http?.postD("/user/login", params);
  };

  /** 首页brands */
  getWxConfig = (data?: any) => {
    return this.http?.getD(`/wx/mp_config`, data);
  };

  /** 首页brands */
  getIndexBrands = (data?: any) => {
    return this.http?.getD(`/brand/base_message`, data);
  };

  /** 点点社区品类 */
  getComType = (data?: any) => {
    return this.http?.getD(`/brand/brand_tree`, data);
  };

  /** 点点社区检索--替换 */
  getNeighborhood = (params?: any) => {
    return this.http?.getD(`/community/neighborhood`, params);
  };

  /** 点点 */
  getPlace = () => {
    return this.http?.getD(`/map/place/areas_code?keyword=310000&sub_district=4`, {});
  };

  /** 点点 */
  getPlaceInfo = (params?: any) => {
    return this.http?.getD(`/map/place/areas_search`, params);
  };

  /** 城市列表 */
  getCities = (params?: any) => {
    return this.http?.getD("/community/all_city", params);
  };

  /** 街道报告 */
  getCoviStreetInfo = (params?: any) => {
    return this.http?.getD("/covid_info/street", params);
  };

  /** 街道报告 */
  getCoviCommunityInfo = (params?: any) => {
    return this.http?.getD("/covid_info/community_report", params);
  };

  /** 区县列表 */
  getCommunities = (params?: any) => {
    return this.http?.getD(`/community/${params.code}`, {});
  };

  /** 品牌列表 */
  getBrands = () => {
    return this.http?.getD(`/brand/brand_tree`, {});
  };

  /** 品牌列表具体品牌 */
  getBrandsType = (params?: any) => {
    return this.http?.getD(`/brand/query_type`, params);
  };

  /** 模糊查询 */
  getLikeQuery = (params?: any) => {
    return this.http?.getD(`/brand/like_query`, params);
  };

  /** 查询数据详情 */
  getQueryDetail = (params?: any) => {
    return this.http?.getD(`/community/query_detail`, params);
  };

  /** 查询社区概要详情 */
  getNeighborhoodOrCommunityDetail = (params?: any) => {
    return this.http?.getD(`/community/neighborhoodOrCommunityDetail`, params);
  };

  /** 查询社区业态 */
  getCommunityCircle = (params?: any) => {
    return this.http?.getD(`/community/communityCircle`, params);
  };

  /** 查询社区业态-15分钟 */
  getCommunityCircle15 = (params?: any) => {
    return this.http?.getD(`/community/arrive_circle`, params);
  };

  /** 查询业态分布 */
  getDistributionFormat = (params?: any) => {
    return this.http?.getD(`/community/distributionFormat`, params);
  };

  /** 查询业态分布 */
  getDistributionFormatPre = (params?: any) => {
    return this.http?.getD(`/community/pre_distributionFormat`, params);
  };

  /** 查询人口规模 */
  getPopulationCount = (params?: any) => {
    return this.http?.getD(`/community/populationCount`, params);
  };

  /** 查询客群特征 */
  getCrowdProfile = (params?: any) => {
    return this.http?.getD(`/community/crowdProfile`, params);
  };

  /** 查询会员报告 */
  getReport = (params?: any) => {
    return this.http?.getD(`/community/report`, params);
  };

  /** 查询推荐点位 */
  getSiteSelect = (params?: any) => {
    return this.http?.getD(`/community/siteSelect`, params);
  };

  /** 获取城市疫情 */
  getCovidInfo = (params?: any) => {
    return this.http?.getD(`/covid_info`, params);
  };

  /** 点点 */
  getCoviInfoCount = () => {
    return this.http?.getD(`/covid_info/count?cityCode=310100`, {});
  };

  /** 点点 */
  getCoviInfoNear = (params?: any) => {
    return this.http?.getD(`/covid_info/nearby_covid`, params);
  };

  /** 点点 */
  getCoviInfoNeed = () => {
    return this.http?.getD(`/covid_info/need_state`, {});
  };

  /** 点点 */
  getCoviInFoCommunity = (params?: any) => {
    return this.http?.getD(`/covid_info/community`, params);
  };

  /** 点点 */
  getCoviInFoCommunityDetail = (params?: any) => {
    return this.http?.getD(`/covid_info/community_detail`, params);
  };

  /** 点点 */
  getCoviInFoCommunityReport = (params?: any) => {
    return this.http?.getD(`/covid_info/community_report`, params);
  };
  
  /** 点点 */
  getCoviInFoCommunityId = (params?: any) => {
    return this.http?.getD(`/covid_info/community_wayz_id`, params);
  };

  /** 获取用户报告 */
  getUserReport = (params?: any) => {
    return this.http?.getD("/report", params);
  };

  /** 获取用户报告 */
  getUserReportDetail = (params?: any) => {
    return this.http?.getD(`/report/${params.id}`, params);
  };

  /** 获取用户报告 */
  uploadUserReport = (params?: any) => {
    return this.http?.postD(`/report/upload`, params);
  };

  /** 获取用户报告 */
  getNearCase = (params?: any) => {
    return this.http?.getD(`/covid_info/nearby_covid_case`, params);
  };

  /** 获取用户报告 */
  getNearMonit = (params?: any) => {
    return this.http?.getD(`/nucleic_acid_agency/near_by`, params);
  };

  /** 核酸检测点 */
  getCoviMonit = (params?: any) => {
    return this.http?.getD(`/nucleic_acid_agency`, params);
  };

  /** 核酸检测点 */
  getCoviMonit1 = (params?: any) => {
    return this.http?.getD(`/nucleic_acid_agency/detail`, params);
  };

  /** 核酸检测点 */
  getCoviMonitPage = (params?: any) => {
    return this.http?.getD(`/nucleic_acid_agency/page`, params);
  };

  /** 核酸检测点 */
  getCoviMonitType = (params?: any) => {
    return this.http?.getD(`/nucleic_acid_agency/place_type_enum`, params);
  };

  /** 价值评估 */
  getInsightDetail = (params?: any) => {
    return this.http?.getD(`/ma_business_circle`, params);
  };
}

export default new Apis();
